import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';

const initState = {
    isBtnLogginTouched: false,
    token: null,
    userId: null,
    email: null,
    agentName: null,
    name: undefined,
    device: undefined,
    extId: undefined,
    isPbxConnected: false,
    PbxConnectionStatus: 'connecting',//connected,notConnected,connecting
    companyId: null,
    permissionType: null,
    canDeleteChat: null,
    error: null,
    loading: false,
    avatar: null,
    urlOnNewContact: undefined,
    companyAgents: [],
    companyExts: [],
    listOfOnlineAgents: [],
    breakName: undefined,
    breakStartTime: undefined,
    breakDurationSec: undefined,
    acdState: undefined,
    breakReasons: undefined,
    isDialerActive: true,
    tempMsgs: [],
    biUrl: undefined,
    facebook_pageAccess: undefined,
    isFaceBookLogged: undefined,
    agent_groupList: [],
    company_groupList: [],
    companyDetails: {},
    mediaTokenData: {}
}

export const getLoggedUserToken = () => {
    console.log('@@@@@@@@@@@@@@@@@@###########')
    console.log(initState.token)
    return initState.token
}

//isPbxConnected
const setPbxConnectedStatus = (state, action) => {
    console.log(action)
    return updateObject(state, { isPbxConnected: action.isPbxConnected, PbxConnectionStatus: action.PbxConnectionStatus });
}

const loginStart = (state, action) => {
    return updateObject(state, { error: null, loading: true, isBtnLogginTouched: action.isBtnLogginTouched });
}

const loginSuccess = (state, action) => {
    return updateObject(
        state,
        {
            token: action.idToken,
            userId: action.userId,
            email: action.email,
            agentName: action.agentName,
            name: action.name,
            companyId: action.companyId,
            permissionType: action.permissionType,
            canDeleteChat: action.canDeleteChat,
            avatar: action.avatar,
            urlOnNewContact: action.urlOnNewContact,
            error: null,
            loading: false,
            device: action.device,
            extId: action.extId,
            biUrl: action.biUrl,
            facebook_pageAccess: action.facebook_pageAccess,
            agent_groupList: action.groupList,
            companyDetails: action.companyDetails,
            isBtnLogginTouched: false,
            lastReadChangeLogTime: action.lastReadChangeLogTime,
            tokenExpiresInMin: action.tokenExpiresInMin,
            supportedMsgTypes: action.supportedMsgTypes
        }
    );
}
const loginFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false,
        isBtnLogginTouched: false
    });
}

const loginLogout = (state, action) => {
    // return updateObject(state, { token: null, userId: null, email: null, agentName: null, companyId: null });
    return initState
}


const fetchAgentsSuccess = (state, action) => {
    return updateObject(state, { companyAgents: action.companyAgents })
}

const fetchGroupsSuccess = (state, action) => {
    return updateObject(state, { company_groupList: action.company_groupList })
}

const fetchCompanyExtsSuccess = (state, action) => {
    return updateObject(state, { companyExts: action.companyExts })
}

const fetchAgentWindowSuccess = (state, action) => {
    // console.log('fetchAgentWindowSuccess data='+JSON.stringify(action.resData))
    return updateObject(state, { ...action.resData })
}
const changeAgentWindowState = (state, action) => {
    // console.log(action.toUpdate)
    return updateObject(state, { ...action.toUpdate })
}

const incBreakSec = (state, action) => {
    const updatedDuration = state.breakDurationSec + (action.numToInc / 1000)
    return updateObject(state, { breakDurationSec: updatedDuration })
}



const companyOnlineAgents = (state, action) => {
    // console.log(action)
    let oldlistOfOnlineAgents = [...state.listOfOnlineAgents]
    if (action.action === 'listOfOnlineAgents') {//if its a new agent online list
        oldlistOfOnlineAgents = action.onlineAgent
    }
    else if (action.action === 'newAgentOnline') {//if new agent now online
        if (!oldlistOfOnlineAgents.some(agent => agent.agentName === action.onlineAgent)) {
            oldlistOfOnlineAgents = oldlistOfOnlineAgents.concat({ agentName: action.onlineAgent })
        }
    }
    else if (action.action === 'updateAgentOnlineExt') {//if new agent now online
        const indexOfAgent = oldlistOfOnlineAgents.findIndex(agent => agent.agentName === action.onlineAgent.agentName)
        if (indexOfAgent > -1) {
            oldlistOfOnlineAgents[indexOfAgent].device = action.onlineAgent.device
        }
    }
    else if (action.action === 'agentLeft') {//if agent no more online
        const indexOfAgent = oldlistOfOnlineAgents.findIndex(agent => agent.agentName === action.onlineAgent)
        if (indexOfAgent > -1) {
            oldlistOfOnlineAgents.splice(indexOfAgent, 1);
        }
    }
    return updateObject(state, { listOfOnlineAgents: oldlistOfOnlineAgents })
}

const changeAgentDialerState = (state, action) => {
    return updateObject(state, { isDialerActive: action.isDialerActive })
}

const fetchAgentTempMsgSuccess = (state, action) => {
    return updateObject(state, { tempMsgs: action.tempMsgs })
}
const fetchFacebookLoginSuccess = (state, action) => {
    return updateObject(state, { isFaceBookLogged: action.isFaceBookLogged })
}
const fetchFacebookSubscribedPages = (state, action) => {
    return updateObject(state, { facebook_pageAccess: action.facebook_pageAccess })
}

// agent_groupList
// company_groupList
// companyAgents

const handleOnAddGroup = (state, action) => {
    let company_groupList = [...state.company_groupList]
    company_groupList.push(action.data)
    return updateObject(state, { company_groupList: company_groupList })
}

const handleOnRemoveGroup = (state, action) => {
    let company_groupList = [...state.company_groupList]
    const toRemoveGroup = action.data
    const groupIndex = company_groupList.findIndex(group => group._id === toRemoveGroup._id)
    if (groupIndex > -1) {
        company_groupList.splice(groupIndex, 1)
    }

    return updateObject(state, { company_groupList: company_groupList })
}

const handleOnAddAgentToGroup = (state, action) => {
    const addedAgentName = action.data.agentName
    const group = action.data.group
    let companyAgents = [...state.companyAgents]
    let companyAgent = companyAgents.find(agent => agent.agentName === addedAgentName)
    if (companyAgent) {
        const isGroupFound = companyAgent.groupList.find(searchGroup => searchGroup.uniqGroupName === group.uniqGroupName)
        if (!isGroupFound) {
            companyAgent.groupList.push(group)
        }
    }
    let agent_groupList = [...state.agent_groupList]
    if (state.agentName === addedAgentName) {
        const isGroupFound = agent_groupList.find(searchGroup => searchGroup.uniqGroupName === group.uniqGroupName)
        if (!isGroupFound) {
            agent_groupList.push(group)
        }
    }
    return updateObject(state, { agent_groupList: agent_groupList, companyAgents: companyAgents })
}

const handleOnRemoveAgentFromGroup = (state, action) => {
    const addedAgentName = action.data.agentName
    const group = action.data.group
    let companyAgents = [...state.companyAgents]
    let companyAgent = companyAgents.find(agent => agent.agentName === addedAgentName)
    if (companyAgent) {
        const groupIndex = companyAgent.groupList.findIndex(searchGroup => searchGroup.uniqGroupName === group.uniqGroupName)
        if (groupIndex > -1) {
            companyAgent.groupList.splice(groupIndex, 1)
        }
    }
    let agent_groupList = [...state.agent_groupList]
    if (state.agentName === addedAgentName) {
        const groupIndex = agent_groupList.findIndex(searchGroup => searchGroup.uniqGroupName === group.uniqGroupName)
        if (groupIndex > -1) {
            agent_groupList.splice(groupIndex, 1)
        }
    }
    return updateObject(state, { agent_groupList: agent_groupList, companyAgents: companyAgents })
}

const refreshMediaToken = (state, action) => {
    const oldMediaTokenData = JSON.parse(JSON.stringify(state.mediaTokenData))
    const newMediaTokenData = { ...oldMediaTokenData, ...action.mediaTokenData }
    return updateObject(state, { mediaTokenData: newMediaTokenData })
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionType.Login_START: return loginStart(state, action);
        case actionType.Login_SUCCESS: return loginSuccess(state, action);
        case actionType.Login_FAIL: return loginFail(state, action);
        case actionType.LOGIN_LOGOUT: return loginLogout(state, action);
        case actionType.FETCH_AGENTS_SUCCESS: return fetchAgentsSuccess(state, action);
        case actionType.FETCH_GROUPS_SUCCESS: return fetchGroupsSuccess(state, action);
        case actionType.FETCH_COMPANY_EXTS_SUCCESS: return fetchCompanyExtsSuccess(state, action);
        case actionType.ONLINE_AGENTS: return companyOnlineAgents(state, action);
        case actionType.FETCH_AGENT_WINDOW_SUCCESS: return fetchAgentWindowSuccess(state, action);//
        case actionType.CHANGE_AGENT_WINDOW_STATE: return changeAgentWindowState(state, action);
        case actionType.INCREASE_BREAK_SEC: return incBreakSec(state, action);
        case actionType.CHANGE_AGENT_DIALER_STATE: return changeAgentDialerState(state, action);
        case actionType.FETCH_AGENT_TEMPMSG_SUCCESS: return fetchAgentTempMsgSuccess(state, action);
        case actionType.SET_PBX_CONNECTED_STATUS: return setPbxConnectedStatus(state, action);//FETCH_FACEBOOK_LOGIN
        case actionType.FETCH_FACEBOOK_LOGIN_SUCCESS: return fetchFacebookLoginSuccess(state, action);
        case actionType.FETCH_FB_SUBS_PAGES: return fetchFacebookSubscribedPages(state, action);
        case actionType.ADD_GROUP: return handleOnAddGroup(state, action);
        case actionType.REMOVE_GROUP: return handleOnRemoveGroup(state, action);
        case actionType.ADD_AGENT_TO_GROUP: return handleOnAddAgentToGroup(state, action);
        case actionType.REMOVE_AGENT_FROM_GROUP: return handleOnRemoveAgentFromGroup(state, action);
        case actionType.REFRESH_MEDIA_TOKEN: return refreshMediaToken(state, action);
        default:
            return state
    }
}

export default reducer;